import type { RouteObject } from "react-router-dom";
import TransitionLayout from "@/components/feature/TransitionLayout";

// A single persistent layout owns the Header/Footer and swaps page content
// with a soft opacity transition. Page routes live in ./pageRoutes.
const routes: RouteObject[] = [
  { path: "*", element: <TransitionLayout /> },
];

export default routes;